module.exports = __webpack_public_path__ + "static/media/upload-document-placeholder.0e17374c.svg";